class WishlistTable extends HTMLElement{
    constructor() {
        super();
 
        this.table = null;
        // this.customerId = window.GLOBAL.customerId;
        // this.cancelConfirm = this.dataset.cancelConfirm;
 
        this.hasCheckbox = this.getAttribute("has-checkbox");
        this.customerId = window.GLOBAL.customerId;
 
        this.wishlist = null;
        this.products = [];
        this.selectedWishlistItems = [];
 
        // const delete_btn = this.querySelector("#delete-btn");
        const wishlist_section = document.querySelector(".js-wishlist-section");
 
        const delete_selected_btns = wishlist_section.querySelectorAll(".delete-selected");
        delete_selected_btns.forEach((e) => e.addEventListener('click', this.handleMultipleDelete.bind(this)))
 
        const add_to_cart = wishlist_section.querySelector("#add-to-cart-selected");
        add_to_cart.addEventListener('click', this.handleMultipleAddToCart.bind(this))
 
        const add_to_cart_all = wishlist_section.querySelector("#add-all-to-cart");
        add_to_cart_all.addEventListener('click', this.handleMultipleAddToCart.bind(this))
 
        const select_all_btn = wishlist_section.querySelector("#select-all-btn");
        select_all_btn.addEventListener('click', this.selectAll.bind(this))
 
        const clearAll = wishlist_section.querySelector("#clear-all");
        clearAll.addEventListener('click', this.clearAll.bind(this))
 
        this.empty = this.dataset.empty
        this.deleteConfirm = this.dataset.deleteConfirm
        this.deleteBtnLabel = this.dataset.deleteButtonLabel;
        this.cartBtnLabel = this.dataset.cartButtonLabel;
        this.locale = this.getAttribute("locale");
        this.outOfStockAlertText = this.dataset.outOfStockAlertText;
        this.hasOutOfStockProduct = false;
 
        this.setup();
    }
 
    setup() {
        window.document.addEventListener('wishlistLoaded', this.init.bind(this));
 
        window.addEventListener("load", async () => {
            await this.init({ detail: window.GLOBAL.wishlist });
        });
    }
 
    async init({ detail }){
        // this.productViewedToday = getProductsViewedToday();
        this.wishlist = detail?.data;
        // this.wishlist = [{ProductID: "9219524297009"}, {ProductID: "9219524460849"}];
        if (!this.wishlist?.length) {
            this.renderNoData()
            return;
        }
 
        let productIds = this.wishlist.map(({ProductID}) => ProductID)
 
        let response = await getProductsByIds(
            productIds,
            `
                title
                handle
                featuredImage { url }
                priceRange{
                    maxVariantPrice { amount }
                    minVariantPrice { amount }
                }
                totalInventory
            `
        );
 
        if (response.result) {
            let products = response.data;
            // console.log(products)
            this.hasOutOfStockProduct = products.some(e => e.totalInventory <= 0)
            // console.log("this.hasOutOfStockProduct", this.hasOutOfStockProduct)
            this.loadTable(products);
        }
    }
 
    loadTable(data){
        const paginationList = document.querySelector(".js-pagination-list")
 
        this.table = new Table(this.querySelector('table'), {
            rowData: data,
            columnDefs: [
                {
                    field: "image",
                    className: "thumbnail cell-left",
                    cellRender: (data) => {
                        let url = data?.featuredImage?.url;
                        let handle = data.handle;
 
                        return `<a href="/products/${handle}">
                        <img src="${url}" alt="">
                        </a>`
                    }
                },
                {
                    field: "title",
                    cellRender: (data) => {
                        // let localeTitle = data.translations.find((e) => e.key === "title")?.value;
                        let title = data.title;
                        let handle = data.handle;
 
                        return `<a style="text-decoration: none; color: black;" href="/products/${handle}">
                        ${title}
                        </a>`;
                    }
                },
                {
                    field: "price",
                    className:"price cell-right",
                    cellRender: (data) => {
                        let price = data?.priceRange?.maxVariantPrice?.amount || 0;
                        const formatter = new Intl.NumberFormat()
                        let formatted = formatter.format(Math.trunc(price))
                        return `${formatted} 원`;
                    }
                },
                {
                    field: "order",
                    className:"cell-center",
                    cellRender: (data) => {
                        let id = this.getRowId(data);
                        // let id = data.id
                        let deleteBtn = document.createElement('button');
 
                        deleteBtn.id = "delete-btn"
                        deleteBtn.className = "btn-normal";
                        deleteBtn.innerText = this.deleteBtnLabel;
                        deleteBtn.addEventListener('click', this.handleDelete.bind(this, { id }));
 
                        let addToCartBtn = document.createElement('button');
 
                        addToCartBtn.id = "add-to-cart"
                        addToCartBtn.className = "btn-normal";
                        addToCartBtn.innerText = this.cartBtnLabel;
                        // console.log('data.totalInventory', data.totalInventory)
                        if(data.totalInventory <= 0){
                            addToCartBtn.disabled = true
                        }
                        addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this, { id }));
 
                        let div = document.createElement("div");
                        div.className = "wishlist-table-btn-group";
                        div.appendChild(deleteBtn);
                        div.appendChild(addToCartBtn);
 
                        return div;
                    }
                }
            ],
            checkboxSelection: true,
            rowIdField: 'id',
            getRowId: this.getRowId,
            paginationList,
            pagination: true,
            paginationPageSize: 10,
            emptyText: this.empty,
            isResponsive: true
            // maxHeight: '300px'
 
        });
    }
 
    getRowId(data) {
        return data.id.split('gid://shopify/Product/')[1]
    }
 
    renderNoData() {
        this.innerHTML = `
        <div class="message">
            ${this.empty}
        </div>
        `
        document.querySelector(".js-pagination-list").style = 'display: none'
        document.querySelector(".js-wishlist-footer").style = 'display: none'
    }
 
 
    async deleteWishlist(items) {
        await removeFromWishlist(items);
    }
 
    async handleDelete({ id }, event) {
        if(confirm(this.deleteConfirm)){
            this.table.deleteRow(id);
            let wishlistItem = this.wishlist.find(({ ProductID }) => ProductID === id);
            await this.deleteWishlist({
                customerId: this.customerId,
                wishListItemId: wishlistItem.WishListItemID,
            });
 
            await this.refreshWishlist();
        }
    }
 
    async handleMultipleDelete() {
        if(confirm(this.deleteConfirm)){
            let selectedProducts = this.table.getSelectedRows();
            for (let item of selectedProducts) {
                let wishlistItem = this.wishlist.find(({ ProductID }) => ProductID === this.getRowId({id: item.id}));
 
                await this.deleteWishlist({
                    customerId: this.customerId,
                    wishListItemId: wishlistItem.WishListItemID,
                });
 
                this.table.deleteRow(this.getRowId({id: item.id}));
 
                await this.refreshWishlist();
            }
        }
    }
 
    async clearAll() {
        if(confirm(this.deleteConfirm)){
            for (let wishlistItem of this.wishlist) {
                this.table.deleteRow(wishlistItem.ProductID);
                await this.deleteWishlist({
                    customerId: this.customerId,
                    wishListItemId: wishlistItem.WishListItemID,
                });
                // this.querySelector(`[data-handle="${wishlistItem.Handle}"]`).remove();
            }
            await this.refreshWishlist();
        }
    }
 
    selectAll(event){
        let checked = event.target.getAttribute("data-checked");
        let flag = !checked || checked === "false" ? true : false;
        event.target.setAttribute("data-checked", flag);
        this.table.selectAll(flag)
    }
 
    async addToCart(cartItems) {
        if(!cartItems.length) return;
 
        let formData = {
            'items': cartItems,
            'sections': 'wishlist,cart',
            'sections_url': window.location.pathname
        };
 
        return await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
 
    }
 
    async handleAddToCart({id}, event){
        let wishlistItem = this.wishlist.find(({ProductID}) => ProductID == id);
 
        if(!wishlistItem) return;
 
        const cartItem = {
            'id': wishlistItem.VariantID,
            'quantity': wishlistItem.Qty
        }
 
        await this.addToCart([cartItem])
 
 
        await this.deleteWishlist({
            customerId: this.customerId,
            wishListItemId: wishlistItem.WishListItemID,
        })
        this.table.deleteRow(id);
 
    }
 
    async handleMultipleAddToCart(event){
        let selectedWishlistItems = [];
        if(event.target.id === "add-all-to-cart"){
            if(this.hasOutOfStockProduct){
                alert(this.outOfStockAlertText)
                return
            }
            selectedWishlistItems = this.wishlist;
        }else{
            let selectedRows = this.table.getSelectedRows();
            const hasOutOfStockSelectedProduct = selectedRows.some(e => e.totalInventory <= 0)
            if(hasOutOfStockSelectedProduct){
                alert(this.outOfStockAlertText)
                return
            }
            selectedWishlistItems = this.wishlist.filter((el) => {
                return selectedRows.some((f) => {
                    return this.getRowId({id: f.id}) === el.ProductID;
                });
            });
 
 
        }
        if(!selectedWishlistItems.length) return;
 
        const cartItems = selectedWishlistItems.map((item) => {
            return {
                'id': item.VariantID,
                'quantity': item.Qty
            }
        });
 
        await this.addToCart(cartItems)
 
        for (let item of selectedWishlistItems) {
            await this.deleteWishlist({
                customerId: this.customerId,
                wishListItemId: item.WishListItemID,
            })
            this.table.deleteRow(item.ProductID);
            // this.querySelector(`[data-handle="${item.Handle}"]`).remove();
        }
 
        // await this.refreshWishlist()
 
    }
 
    async refreshWishlist() {
        window.GLOBAL.wishlist = await getWishlist();
        this.wishlist = window.GLOBAL.wishlist.data;
        const event = new window.CustomEvent('wishlistLoaded', { detail: window.GLOBAL.wishlist })
        window.document.dispatchEvent(event);
 
        if (!this.wishlist.length) {
            this.renderNoData()
        }
    }
}
 
customElements.define("wishlist-table", WishlistTable);